import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  input,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { TableOverlayColumnAssignmentItemComponent } from './table-overlay-column-assignment-item/table-overlay-column-assignment-item.component';
import { TableData } from '../../../../../table-overlay/table-overlay';
import { Keys } from '@ps-gui/shared-core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Dimension2d, WordRect } from '@ps-gui/claims-terminal-shared';

@Component({
  selector: 'ct-extraction-table-overlay-column-assignment',
  imports: [TableOverlayColumnAssignmentItemComponent],
  templateUrl: './table-overlay-column-assignment.component.html',
})
export class TableOverlayColumnAssignmentComponent implements OnInit {
  @Input({ required: true }) tableData!: TableData;
  readonly absoluteTableRect = input.required<WordRect>();
  @Input({ required: true }) dimension!: Dimension2d;

  @Output() newTableHeaderAtColumnPosition = new EventEmitter<{
    colPos: number;
    newHeader: string;
  }>();

  @ViewChildren(TableOverlayColumnAssignmentItemComponent)
  menuChildren!: QueryList<TableOverlayColumnAssignmentItemComponent>;
  protected openedMenuIndex!: number | undefined;

  private readonly destroyRef = inject(DestroyRef);

  readonly tableColumnLabelsByKeys = input.required<Record<string, string>>();

  ngOnInit() {
    this.openedMenuIndex = this.tableData.confirmed()
      ? undefined
      : this.tableData.columnHeaders().findIndex((header) => !header);

    Keys.Escape.down
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.closeOpenedMenu());
  }

  protected openMenuIfTableDataIsNotConfirmedAndCloseMenuIfOpened(columnIndex: number) {
    if (this.tableData.confirmed()) return;
    this.openedMenuIndex = columnIndex;
  }

  protected closeOpenedMenu() {
    this.openedMenuIndex = undefined;
  }

  private openNextUndefinedMenu(columnIndex: number) {
    const headers = this.tableData.columnHeaders;

    let nextUnsetColumnHeaderIndex = headers().findIndex((header) => !header);
    if (nextUnsetColumnHeaderIndex > -1)
      nextUnsetColumnHeaderIndex = headers().findIndex(
        (header, index) => !header && index >= columnIndex,
      );

    if (nextUnsetColumnHeaderIndex === -1) {
      this.closeOpenedMenu();
      return;
    }

    this.openMenuIfTableDataIsNotConfirmedAndCloseMenuIfOpened(nextUnsetColumnHeaderIndex);
  }

  setNewTableHeaderAtColumnPosition(colPos: number, newHeader: string) {
    this.newTableHeaderAtColumnPosition.emit({ colPos, newHeader });
    this.openNextUndefinedMenu(colPos);
  }
}
